
/**
 * src/web/components/kpi-panel.jsx
 * グループ設定のKPI設定ページ
 */

import React from 'react'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import theme from './themes/flat-card.css'
import {
  List,
  ListItem,
  ListCheckbox,
  ListSubHeader,
} from 'react-toolbox/lib/list'
import FontIcon from 'react-toolbox/lib/font_icon'
import Checkbox from 'react-toolbox/lib/checkbox'
import ConfirmDialog from './confirm-dialog.jsx'
import Loading from './loading.jsx'
import _ from 'lodash'
import moment from 'moment'
import { formatNumber } from '../../helpers/format-number'
import successButtonTheme from './themes/success-button.css'
import lightButtonTheme from './themes/light-button.css'
import sortableTheme from './themes/sortable.css'
import ListSortingTheme from './themes/group-members-sorting.css'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'

function formatKpi(kpi, t) {
  var assignedMembers
  if (kpi.assignments.length == 0)
    assignedMembers = t('label:割り当てられていません')
  else
    assignedMembers = kpi.assignments.slice(0, 3).map((assignment)=> assignment.name).join(',')
  if (kpi.assignments.length > 3)
    assignedMembers += '... ' + t('label:他n人', { n: kpi.assignments.length - 3})

  const dateRange = `${moment(kpi.start_date).format('llll')} - ${moment(kpi.end_date).format('llll')}`
  const targetNum = formatNumber(kpi.target, kpi.display_format)

  return `${dateRange}, ${t('label:目標値', { value: targetNum })}, ${t('label:担当者', { assignments: assignedMembers })}`
}


class _KPIListItem extends React.Component {
  state = { showMenu: false, kpiSelect: false }

  UNSAFE_componentWillUpdate(nextProps) {
    if(this.props.ui.onCheck != nextProps.ui.onCheck){
      this.setState({ kpiSelect: false })
    }
  }

  onSelectKpi = (kpi)=> {
    this.setState({kpiSelect: true })
    this.props.pushKpi(this.props, kpi)
  }

  onExclusionKpi = (kpi)=> {
    this.setState({kpiSelect: false })
    this.props.exclusionKpi(this.props, kpi)
  }

  render() {
    const {
      t,
      ui,
      kpi,
      newKpi,
      editKpi,
      downloadUrl,
      deleteKpi,
      isFetching,
      onCheck,
      pushKpi,
      exclusionKpi,
      updateUI,
    } = this.props

    return (
      <ListItem key={kpi.kpi_id} selectable={true} ripple={true}
        theme={ListSortingTheme}
        className={'text_ellipsis'}
        leftIcon={this.props.ui.onCheck ? 
          <Checkbox checked={this.state.kpiSelect} onChange={()=> this.props.ui.checkKpi && this.props.ui.checkKpi.find((v) =>  v.kpi_id == kpi.kpi_id ) ? this.onExclusionKpi(kpi) : this.onSelectKpi(kpi)}/> : "insert_chart"}
        caption={kpi.name}
        legend={formatKpi(kpi, t)}
        onClick={!this.props.ui.onCheck ? ()=> editKpi(this.props, kpi.kpi_id) : null }
        rightActions={!this.props.ui.onCheck && [
          <IconMenu key="menu" icon='more_vert' onClick={()=> this.setState({ showMenu: true })}>
            <MenuItem disabled={isFetching}
                icon="content_copy"
                onClick={()=> newKpi(this.props, kpi, false)}
                caption={t('label:コピーして新規作成')} />
            <MenuItem disabled={isFetching}
                icon="content_copy"
                onClick={()=> newKpi(this.props, kpi, true)}
                caption={t('label:コピーして翌期分を作成')} />
            <MenuItem disabled={isFetching}
                icon="delete_forever"
                onClick={()=> this.setState({ deleteConfirm: true })}
                caption={t('label:データごと削除')} />
          </IconMenu>,
          <ConfirmDialog key="dialog"
              title={t('label:KPIを削除してもいいですか', { name: kpi.name })}
              description={t('label:この操作は取り消せません')}
              open={this.state.deleteConfirm}
              yesLabel={t('label:削除')}
              noLabel={t('label:取り消し')}
              onYes={()=> { this.setState({ deleteConfirm: false }); deleteKpi(kpi) }}
              onNo={()=> this.setState({ deleteConfirm: false })} />,
        ]} />
    )
  }
}

const RawKPIListItem = _KPIListItem
const KPIListItem = SortableElement(_KPIListItem)

const SortableKPIList = SortableContainer(function(props) {
  const {
    t,
    ui,
    kpis,
    isFetching,
    sorting,
    onCheck,
    pushKpi,
    exclusionKpi,
    updateUI,
  } = props

  return (
    <div style={{ cursor: sorting && 'move' || 'inherit' }}>
    <List selectable>
      <ListItem caption={t('label:現在のKPI')} selectable={false} ripple={false}/>
      {isFetching && (!kpis || kpis.length == 0) && <Loading />}
      {!isFetching && (!kpis || kpis.length == 0) &&
        <ListItem caption={t('label:KPIは登録されていません')} selectable={false} ripple={false} />
      }
      {kpis && kpis.length > 0 &&
        _.map(kpis, (kpi, i) => <KPIListItem key={kpi.kpi_id} {...props} kpi={kpi} index={i} disabled={!sorting} />)
      }
    </List>
    </div>
  )
})

class KPIPanel extends React.Component {
  state = {}

  newKpi = (props)=> {
    this.props.updateUI({ checkKpi: undefined })
    this.props.newKpi(props)
  }

  onSortEnd = (index)=> {
    this.props.sortKpis(this.props, arrayMove(this.props.kpis.map((item)=> item.kpi_id), index.oldIndex, index.newIndex))
  }
  startSorting = ()=> {
    this.setState({ sorting: !this.state.sorting })
    !this.state.sorting && this.props.startSorting()
  }
  finishSort = () => {
    this.setState({ sorting: false })
  }
  onCheck = ()=> {
    this.props.updateUI({ onCheck: true})
  }
  onCancel = ()=> {
    this.props.updateUI({ checkKpi: undefined })
    this.props.updateUI({ onCheck: false})
  }

  downloadKpi = (kpi)=> {
    if(kpi && kpi.length != 0){
      const kpiList = kpi.map(item => item['kpi_id'])
      window.open(this.props.downloadUrl(kpiList))
    }else{
      this.props.notKpiMessage()
    }
  }

  render() {
    const {
      t,
      ui,
      kpis,
      closedKpis,
      sortKpis,
      newKpi,
      editKpi,
      deleteKpi,
      downloadUrl,
      pushKpi,
      exclusionKpi,
      isFetching,
      hasMoreClosedKpis,
      updateUI,
      fetchClosedKpis,
      startSorting,
    } = this.props

    return (
      <Card theme={theme}>
        <CardActions>
          <Button raised theme={successButtonTheme}
            icon='add'
            label={t('label:新規作成')}
            onClick={() => this.newKpi(this.props)} />
          {!this.props.ui.onCheck && kpis && kpis.length > 1 && 
            <Button raised={this.state.sorting}
              theme={lightButtonTheme}
              icon={!this.state.sorting ? 'sort' : 'check'}
              label={!this.state.sorting ? t('label:並べ替え') : t('label:並べ替えを終了')}
              onClick={!this.state.sorting ? this.startSorting : this.finishSort} />
          }
        </CardActions>
        <CardActions style={{ marginLeft: 'auto'}}>
          {this.props.ui.onCheck &&
          <Button raised theme={successButtonTheme}
            icon='download'
            label={t('label:Excelダウンロード')}
            onClick={() => this.downloadKpi(ui.checkKpi)}
            />}
          <Button raised primary
            icon={this.props.ui.onCheck ? 'close' : 'add'}
            label={this.props.ui.onCheck ? "キャンセル" : "KPIを選択"}
            onClick={this.props.ui.onCheck ? this.onCancel : this.onCheck} />
        </CardActions>

        {this.props.ui.onCheck &&
        <div>
          <FontIcon value='info' style={{ verticalAlign: 'bottom',marginLeft: 30 }}/>
          <span style={{ marginLeft: 10 }}>{t('label:KPIを選択してください')}</span>
        </div>}

        {this.state.sorting && 
        <div>
          <FontIcon value='info' style={{ verticalAlign: 'bottom',marginLeft: 30 }}/>
          <span style={{ marginLeft: 10 }}>{t('label:並べ替え終了を選択')}</span>
        </div>}

        <CardText>
          <SortableKPIList {...this.props}
            sorting={this.state.sorting}
            onSortEnd={this.onSortEnd}
            onCheck={this.props.ui.onCheck}
            pushKpi={pushKpi}
            exclusionKpi={exclusionKpi}
            updateUI={updateUI}
            helperClass={sortableTheme.sortable} />

          <List selectable>
            <ListItem caption={t('label:終了したKPI')}
                selectable={true}
                rightIcon={ui.showClosedKpi && "arrow_drop_up" || "arrow_drop_down"}
                onClick={()=> {
                  !ui.showClosedKpi && fetchClosedKpis(this.props, true)
                  updateUI({ showClosedKpi: !ui.showClosedKpi })
                }} />
            {isFetching && kpis && kpis.length > 0 &&
              ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) && <Loading />}
            {!isFetching && ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) &&
                <ListItem caption={t('label:KPIは登録されていません')} selectable={false} ripple={false} />
            }
            {ui.showClosedKpi && closedKpis && closedKpis.length > 0 &&
              _.map(closedKpis, (kpi) => <RawKPIListItem key={kpi.kpi_id} {...this.props} kpi={kpi} pushKpi={pushKpi} exclusionKpi={exclusionKpi} onCheck={this.props.ui.onCheck} disabled />)
            }
            {!isFetching && ui.showClosedKpi && closedKpis && closedKpis.length > 0 && hasMoreClosedKpis &&
                <ListItem selectable={false} ripple={false} rightActions={[
                  <Button flat key="more" icon="arrow_drop_down"
                      label={t('label:続きを表示')}
                      onClick={()=> fetchClosedKpis(this.props)} />
                ]} />
            }
          </List>
        </CardText>
      </Card>
    )
  }
}

export default KPIPanel



// WEBPACK FOOTER //
// ./src/web/components/kpi-panel.jsx